import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Subject, takeUntil } from 'rxjs';
import { NewSupplier$Params } from 'src/api/generated/fn/supplier/new-supplier';
import { UpdateSupplier$Params } from 'src/api/generated/fn/supplier/update-supplier';
import { AddSupplierDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Suppliers/add-supplier-dto';
import { SupplierDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Suppliers/supplier-dto';
import { UpdateSupplierDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Suppliers/update-supplier-dto';
import { SupplierService } from 'src/api/generated/services';

@Component({
  selector: 'app-add-or-edit-supplier',
  templateUrl: './add-or-edit-supplier.component.html',
  styleUrls: ['./add-or-edit-supplier.component.scss']
})
export class AddOrEditSupplierComponent implements OnInit {
 
  public editFlag: boolean = false;
  public supplierId :string;
  public unsubscribe: Subject<void> = new Subject<void>();
  public supplierDto: SupplierDto = {} as SupplierDto;

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private supplierService: SupplierService) {

    if (this.config.data != undefined) {
      if (this.config.data.item) {
        this.supplierDto.name = this.config.data.item.name;
        this.supplierDto.address = this.config.data.item.address;
        this.supplierDto.email = this.config.data.item.email;
        this.supplierDto.phone = this.config.data.item.phone;       
        this.supplierDto.id = this.config.data.item.id;
        this.editFlag = true;
      }
    }
  }

  ngOnInit(): void {
  }

  addSupplier(f: NgForm) {  
    if(f.valid){
      var params: NewSupplier$Params = {} as NewSupplier$Params;
      const addSupplier: AddSupplierDto = { name: this.supplierDto.name, address: this.supplierDto.address, email: this.supplierDto.email, phone: this.supplierDto.phone };
      params.body = addSupplier;
      this.supplierService.newSupplier(params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.ref.close(true)
          },
          error: errorResponse => {
          }
        });
    }
  }
  editSupplier(f: NgForm) {
    if(f.valid){
      var params: UpdateSupplier$Params = {} as UpdateSupplier$Params;
      const editSupplier: UpdateSupplierDto = { name: this.supplierDto.name, address: this.supplierDto.address, email: this.supplierDto.email, phone: this.supplierDto.phone };
      if(this.supplierDto.id){
        params.supplierId = this.supplierDto.id;
      }
      params.body = editSupplier;
      this.supplierService.updateSupplier(params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.ref.close(true)
          },
          error: errorResponse => {
          }
        });
    }
  }
  cancel() {
    this.ref.close(null);
  }

}
